import React from "react";
import PropTypes from "prop-types";
import { Button, IconButton, Typography } from "@material-ui/core";

import { useScreen } from "hooks";

import LinkStyledButton from "../LinkStyledButton";

import useStyles from "./useStyles";

const Identity = ({ type, icon, action }) => {
  const classes = useStyles();
  const { isMobile } = useScreen();
  const isConnected = type.includes("disconnect");

  return (
    <>
      {isMobile ? (
        <div className={classes.row}>
          <IconButton aria-label={type} className={classes.service} onClick={action}>
            <img src={icon} alt={type} className={classes.service} />
          </IconButton>
          <div className={classes.service}>
            <Typography onClick={action}>
              <b>{isConnected ? "Connected" : "Disconnected"}</b>
            </Typography>

            <LinkStyledButton handleClick={action}>{isConnected ? "Disconnect" : "Connect"}</LinkStyledButton>
          </div>
        </div>
      ) : (
        <div className={classes.row}>
          <Button className={classes.service} onClick={action}>
            <img src={icon} alt={type} className={classes.service} />
            <Typography>
              <b>{isConnected ? "Connected" : "Disconnected"}</b>
            </Typography>
          </Button>

          <LinkStyledButton handleClick={action}>{isConnected ? "Disconnect" : "Connect"}</LinkStyledButton>
        </div>
      )}
    </>
  );
};

Identity.propTypes = {
  type: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

export default Identity;
